import {makeDefaultRxList} from '../../../utils/rx-helper';
import sleep from 'sleep-promise';

import API from './api';


export async function fetchRxHistory(rawSequences) {
  const existPatientIds = new Set();
  const _idPtAliasMap = {};
  const newPatientRawSequences = [];
  let result = [];
  for (const seq of rawSequences) {
    const {isolateType, existingPatientId, ptAlias, uuid} = seq;
    if (isolateType !== 'Clinical') {
      // RxHistory is only required for clinical isolates
      continue;
    }
    if (existingPatientId) {
      existPatientIds.add(existingPatientId);
      _idPtAliasMap[existingPatientId] = [ptAlias, uuid];
    }
    else {
      newPatientRawSequences.push(seq);
    }
  }
  if (newPatientRawSequences.length > 0) {
    result = makeDefaultRxList(newPatientRawSequences);
  }
  if (existPatientIds.size === 0) {
    return result;
  }

  await sleep(0);
  const data = await API({patientIds: Array.from(existPatientIds)});
  const {viewer: {patients}} = data;
  if (!patients) {
    return result;
  }
  const existingRxHistory = [];
  for (let {node: {id, treatments}} of patients.edges) {
    id = parseInt(atob(id).split(':')[1]);
    const [ptAlias, uuid] = _idPtAliasMap[id];
    for (const {
      dateMatch, startDate, stopDate,
      durationUnknown, orderUnknown, regimenName
    } of treatments) {
      existingRxHistory.push({
        existingPatientId: id,
        rawSequenceUuid: uuid,
        ptAlias, startDateMatch: dateMatch,
        startDate, stopDate,
        stopDateMatch: '=',
        durationUnknown: durationUnknown ? 'Yes' : 'No',
        orderUnknown: orderUnknown ? 'Yes' : 'No',
        drugs: (regimenName || '').split(/\s*\+\s*/).join(',')
      });
    }
  }
  return existingRxHistory.concat(result);
}

export async function fetchDrugNames(rawDataCollection) {
  const {rawRxHistory} = rawDataCollection;
  let allDrugs = new Set();
  for (const rxData of rawRxHistory) {
    const {drugs} = rxData;
    for (const drug of drugs.split(',')) {
      if (drug.trim()) {
        allDrugs.add(drug.trim());
      }
    }
  }
  allDrugs = Array.from(allDrugs);
  if (allDrugs.length === 0) {
    return rawDataCollection;
  }

  const data = await API({drugNames: allDrugs});
  const {viewer: {luDrugs}} = data;
  if (!luDrugs.edges) {
    return rawDataCollection;
  }
  if (!rawDataCollection.validDrugs) {
    rawDataCollection.validDrugs = {};
  }
  Object.assign(
    rawDataCollection.validDrugs,
    luDrugs.edges.reduce(
      (acc, {node: {drugName, drugClass}}) => {
        acc[drugName] = drugClass;
        return acc;
      }, {}
    )
  );
  return rawDataCollection;
}



// WEBPACK FOOTER //
// ./src/views/wizard/rx-list/fetch-rx-history.js